import { render, staticRenderFns } from "./SupplierOrderDetail1.vue?vue&type=template&id=393abe34&scoped=true&"
import script from "./SupplierOrderDetail1.vue?vue&type=script&lang=js&"
export * from "./SupplierOrderDetail1.vue?vue&type=script&lang=js&"
import style0 from "./SupplierOrderDetail1.vue?vue&type=style&index=0&id=393abe34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393abe34",
  null
  
)

export default component.exports